import Cookies from 'js-cookie';

// Check for Umbraco backoffice authentication on page load (for CDN caching)
window.addEventListener("DOMContentLoaded", function() {
    // Check if user is logged into Umbraco backoffice
    // Umbraco uses cookies starting with "UMB-" or "UMB_"
    const allCookies = document.cookie;
    const hasUmbracoAuth = allCookies.includes('UMB-XSRF-TOKEN') || 
                           allCookies.includes('UMB_UCONTEXT') ||
                           /UMB[-_]/.test(allCookies);
    
    if (hasUmbracoAuth) {
        // Show Umbraco admin link for authenticated backoffice users
        const umbracoAdminLink = document.querySelector('[data-umbraco-admin-link]');
        if (umbracoAdminLink) {
            umbracoAdminLink.style.display = '';
            umbracoAdminLink.removeAttribute('hidden');
        }
        
        // Show theme tools for authenticated users in non-production environments
        // Production detection: check if hostname contains production indicators
        const hostname = window.location.hostname.toLowerCase();
        const isProduction = !hostname.includes('local') && 
                            !hostname.includes('dev') && 
                            !hostname.includes('uat') && 
                            !hostname.includes('staging') &&
                            !hostname.includes('test');
        
        if (!isProduction) {
            const themeTools = document.querySelector('[data-theme-tools]');
            if (themeTools) {
                themeTools.style.display = '';
                themeTools.removeAttribute('hidden');
                
                // Update selected theme from cookies
                const themeBrand = Cookies.get('merlin-theme-brand');
                const themeSite = Cookies.get('merlin-theme-site');
                
                if (themeBrand || themeSite) {
                    const themeList = themeTools.querySelector('[data-theme-list]');
                    if (themeList) {
                        // Remove all existing isSelected classes
                        themeList.querySelectorAll('.isSelected').forEach(el => el.classList.remove('isSelected'));
                        
                        // Find and mark the selected theme
                        themeList.querySelectorAll('.merlintoolbox-btn').forEach(btn => {
                            const btnBrand = btn.getAttribute('data-theme-brand');
                            const btnSite = btn.getAttribute('data-theme-site') || '';
                            
                            if (btnBrand && btnBrand.toLowerCase() === (themeBrand || 'neutral').toLowerCase()) {
                                if (!themeSite || btnSite.toLowerCase() === themeSite.toLowerCase()) {
                                    btn.closest('li').classList.add('isSelected');
                                }
                            }
                        });
                    }
                }
            }
        }
    }
});